import { Address, AddressWithMeta } from './address';
import { IdentityTypeDirectors } from './director-details';

export type Contact = {
  identityType?: IdentityTypeDirectors;
  idNumber?: string;
  name?: string;
  surname?: string;
  emailAddress?: string;
  mobileNumber?: string;
  gender?: string;
  consumerType?: ConsumerType;
  businessAddress?: Address;
  residentialAddress?: AddressWithMeta;
  isResidentialAddressSameAsBusinessAddress?: boolean;
  title?: string;
  initials?: string;
  maritalStatus?: string;
  selfieImageBase64?: string;
  selfieImageFileName?: string;
  dateOfBirth?: Date;
  passportExpiryDate?: Date;
  countryOfOrigin?: string;
};

export enum IdentityType {
  RSA_ID = 'RSA ID',
  FOREIGN_NATIONAL = 'FOREIGN NATIONAL',
}

export enum ForeignNationalType {
  PASSPORT = 'Passport',
  REFUGEE = 'Refugee',
  ASYLUM_SEEKER = 'Asylum Seeker',
}

export enum AddressType {
  RESIDENTIAL = 'residential',
  BUSINESS = 'business',
}

export enum ConsumerType {
  DIRECTOR,
  ASSISTANT,
}

export enum TITLES {
  MR = 'Mr',
  MRS = 'Mrs',
  MISS = 'Miss',
  DR = 'Dr',
  PROF = 'Prof',
}
export enum CREDIT_VETTING_TITLE {
  MR = 'Mr',
  MRS = 'Mrs',
  MISS = 'Miss',
  DR = 'Dr',
}

export enum MARITAL_STATUSES {
  MARRIED = 'Married',
  SINGLE = 'Single',
  DIVORCED = 'Divorced',
  WIDOWED = 'Widowed',
}
